import { Button } from '@/components/Common';
import { Header } from '@/components/Layout/Header/Header';
import { Tabs } from '@/components/Ui';
import newTab from '@/assets/icons/new-tab.svg';
import QuestionForm from '@/components/Views/QuestionForm/QuestionForm';
import ListWithSubItems from '@/components/shared/ListWithSubItems';
import { Divider } from 'primereact/divider';
import { AddTest } from '@/pages/BlankExam/SettingUpTests/AddTest';
import { useSettingUpTests } from '@/pages/BlankExam/SettingUpTests/SettingUpTest.hook';
import QuestionDeletionModal from './QuestionDeletionModal';
import ExerciseDeletionModal from './ExerciseDeletionModal';

export const SettingUpTests = () => {
  const {
    exerciseTabs,
    handleEditTab,
    activeTabExercise,
    setActiveTabExercise,
    setIsOpenExamModal,
    QuizzQuestionType,
    register,
    errors,
    handleSubmit,
    setValue,
    handleSelectedType,
    selectedType,
    response1Check,
    setResponse1Check,
    response2Check,
    setResponse2Check,
    response3Check,
    setResponse3Check,
    response4Check,
    setResponse4Check,
    selectedQuizz,
    questions,
    handleSelectedQuizz,
    quizzMenuItems,
    selectedExercise,
    handleCreateQuestion,
    handleUpdateQuestion,
    isEditingQuestion,
    handleOpenDeleteModal,
    isCreateQuestionPending,
    loadingUpdateQuestion,
  } = useSettingUpTests();

  const onSubmit =
    selectedQuizz && isEditingQuestion
      ? handleUpdateQuestion
      : handleCreateQuestion;

  return (
    <div>
      <Header title="Configurer les epreuves" goBack />
      <div className="flex flex-col gap-4">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-4 items-start mb-10">
          <div className="overflow-x-auto w-full">
            <Tabs
              tabs={exerciseTabs}
              activeIndex={activeTabExercise}
              setActiveIndex={setActiveTabExercise}
              showAction={true}
              onDelete={(id) => handleOpenDeleteModal(id)}
              onEdit={handleEditTab}
              type={'evaluation'}
            />
          </div>
          <Button
            className="inline !bg-transparent !p-0 hover:!bg-transparent size-8 shrink-0"
            icon={<img src={newTab} alt="addModule" />}
            onClick={() => setIsOpenExamModal(true)}
          />
        </div>

        <div className="relative grid grid-cols-[33%_auto] gap-4 overflow-x-hidden mb-10">
          <div className="w-full">
            <h1 className="font-bold text-2xl text-white mb-10 mt-6">
              {isEditingQuestion ? 'Modifier question' : 'Ajouter question'}
            </h1>
            <QuestionForm
              QuizzQuestionType={QuizzQuestionType}
              initialSelectedOptions={
                selectedQuizz && isEditingQuestion
                  ? { _id: selectedQuizz.type, name: selectedQuizz.type }
                  : undefined
              }
              register={register}
              errors={errors}
              handleSubmit={handleSubmit}
              onSubmit={onSubmit}
              setValue={setValue}
              handleSelectedType={handleSelectedType}
              selectedType={selectedType}
              response1Check={response1Check}
              setResponse1Check={setResponse1Check}
              response2Check={response2Check}
              setResponse2Check={setResponse2Check}
              response3Check={response3Check}
              setResponse3Check={setResponse3Check}
              response4Check={response4Check}
              setResponse4Check={setResponse4Check}
              submitButtonText={
                isCreateQuestionPending || loadingUpdateQuestion
                  ? 'En cours...'
                  : isEditingQuestion
                    ? 'Modifier question'
                    : 'Ajouter question'
              }
            />
          </div>
          <Divider
            layout="vertical"
            className="absolute left-1/3 top-0 bg-dimGray w-[1px]"
          />
          <div className="w-full pl-20">
            <div className="ml-5 overflow-y-scroll overflow-x-auto h-[calc(100vh_-_110px)]">
              <ListWithSubItems
                items={questions || []}
                selectedItem={selectedQuizz}
                onItemSelect={handleSelectedQuizz}
                menuItems={quizzMenuItems}
              />
            </div>
          </div>
        </div>
      </div>
      <AddTest selectedExercise={selectedExercise} />
      <QuestionDeletionModal />
      <ExerciseDeletionModal />
    </div>
  );
};
